import { useEffect, useState } from 'react';

import { Variants, motion } from 'framer-motion';
import { useWindowSize } from 'codekit';

import * as Icons from 'icons';
import { howItWorksSteps } from 'constants/home';

import { InfoGraphicHowItWorksContainer } from './styles';

const arrowRadiusContainer: Variants = {
	hidden: { opacity: 1, scale: 0, transform: 'translate(-50%, -50%)' },
	visible: {
		opacity: 1,
		scale: 1,
		transform: 'translate(-50%, -50%)',
		transition: {
			delayChildren: 0.3,
			staggerChildren: 1.2,
			repeat: Infinity,
		},
	},
};

const arrowRadiusVariants: Variants = {
	hidden: {
		opacity: 0,
		pathLength: 0,
		transition: {
			duration: 0.1,
		},
	},
	visible: {
		opacity: 1,
		pathLength: 1,
		transition: {
			duration: 1,
		},
	},
};

function InfoGraphicHowItWorks() {
	// Hooks
	const { isMobile } = useWindowSize();

	// States
	const [isAnimating, setIsAnimating] = useState(true);
	const [factor, setFactor] = useState(0.75);

	// Effects
	useEffect(() => {
		const interval = setInterval(() => {
			setIsAnimating((prev) => !prev);

			setTimeout(() => setIsAnimating((prev) => !prev), 300);
		}, 5800);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const callback = () => {
			const content = document.querySelector('.content');
			if (!content) return;

			const width = isMobile ? content.clientWidth : 600;
			const factor = width / 800;

			setFactor(factor);
		};

		window.addEventListener('resize', callback);
		callback();

		return () => {
			window.removeEventListener('resize', callback);
		};
	}, [isMobile]);

	return (
		<InfoGraphicHowItWorksContainer factor={factor}>
			{howItWorksSteps.map((step) => (
				<div
					key={step.ref}
					className={`step step-${step.ref} ${step.slug}`}
				>
					<div className="step-content">
						<step.icon />
						<span>{step.shortName}</span>
					</div>
				</div>
			))}

			<div className="step step-end delivery">
				<div className="step-content">
					<Icons.StepsEndIcon />
					<span>Sua empresa</span>
				</div>
			</div>

			<div className="stack" />
			<div className="dashed-radius" />

			<motion.div
				className="arrows-radius"
				variants={arrowRadiusContainer}
				initial="hidden"
				// animate={'visible'}
				key={isAnimating ? 'animate' : 'reset'}
				animate={isAnimating ? 'visible' : 'hidden'}
			>
				<Icons.StepsRadiusArrowsBottomLeft
					variants={arrowRadiusVariants}
				/>
				<Icons.StepsRadiusArrowsTopLeft
					variants={arrowRadiusVariants}
				/>
				<Icons.StepsRadiusArrowsTopRight
					variants={arrowRadiusVariants}
				/>
				<Icons.StepsRadiusArrowsBottomRight
					variants={arrowRadiusVariants}
				/>
			</motion.div>

			<div className="step-one text"></div>
		</InfoGraphicHowItWorksContainer>
	);
}

export default InfoGraphicHowItWorks;
